import { render, staticRenderFns } from "./EconomicLeft.vue?vue&type=template&id=0ba66352&scoped=true&"
import script from "./EconomicLeft.vue?vue&type=script&lang=js&"
export * from "./EconomicLeft.vue?vue&type=script&lang=js&"
import style0 from "./EconomicLeft.vue?vue&type=style&index=0&id=0ba66352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba66352",
  null
  
)

export default component.exports